(function () {
    'use strict';
    a3_cabin_reports.controller('AssessmentCtrl', AssessmentCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name AssessmentCtrl
    * @description 
    *   Manages the Cabin Crew Feedback View 
    * @ngInject
    */
    function AssessmentCtrl($scope, $location, CrewAssessmentFactory, $routeParams, SettingsMain, orderByFilter, FlightFactory, $timeout, localStorageMD5Service) {

        var editingPage = SettingsMain.getEditingPage();
        var flightId = $routeParams.flightId;
        var minDate, maxDate, flightRouteString, crewAssessment;
        
        SettingsMain.setEditingPage("assessment");
        var text = "";

        if (flightId == "temp") {
            crewAssessment = CrewAssessmentFactory.getTempAssessment();

            $scope.flight = FlightFactory.getFlightFromStorage(crewAssessment.FlightId);
            SettingsMain.setEditingPage(null);
        } else {
            $scope.flight = FlightFactory.getFlightFromStorage(flightId);

            if ($scope.flight.assessment) {
                crewAssessment = CrewAssessmentFactory.getCrewAssessmentFromStorage($scope.flight.assessment.Id);
            }
        }

        if (crewAssessment) {

            var flights = orderByFilter(crewAssessment.Flights, orderByDate, false);
            for (var i = 0; i < flights.length; i++) {
                if (i == 0) {
                    minDate = flights[i].ScheduledDepartureDateUTC + "T" + flights[i].ScheduledDepartureTimeUTC;
                    flightRouteString = flights[i].Departure
                } else if (i == (flights.length - 1)) {
                    maxDate = flights[i].ScheduledArrival;
                    flightRouteString = flightRouteString + "-" + flights[i].Departure + "-" + flights[i].Arrival;
                } else {
                    flightRouteString = flightRouteString + "-" + flights[i].Departure;
                }
            }

            var route = {
                Route: crewAssessment.Route,
                DutyDate: crewAssessment.DutyDate,
                MinDate: minDate,
                MaxDate: maxDate,
                FlightRoute: flightRouteString,
                FeedbackDate: crewAssessment.FeedbackDate
            }

            for (var i = 0; i < crewAssessment.assessedBy.length; i++) {
                if (i > 0) {
                    var assessed = ', ' + crewAssessment.assesedBy[i].Name;
                } else {
                    var assessed = crewAssessment.assessedBy[i].Name;
                }
                text = text.concat(assessed);
            }

            $scope.isFirstOpen = true;
            $scope.assessment = crewAssessment;
            $scope.togglePanel = togglePanel;
            $scope.route = route;
            $scope.assessedBy = text;
        }

        $scope.clearRemarks = clearRemarks;
        $scope.avgValue = avgValue;
        $scope.updateValues = updateValues;
        $scope.IsCompleted = IsCompleted;
        $scope.IsSynched = IsSynched;
        $scope.assessments_not_completed = CrewAssessmentFactory.getCountOfUncompletedAssessments();
        $scope.saveClicked = saveClicked;
        $scope.saveDraftClicked = saveDraftClicked;
        $scope.assesmentCSSClass = assesmentCSSClass;
        $scope.assesmentIconClass = assesmentIconClass;
        $scope.isPanelOpen = true;
        $scope.discard = discard;

        $scope.infosaveaction = false;

        // kzan:: test reasons
        $scope.feedbackDate = $scope.flight.ScheduledDepartureDateUTC;
        $scope.hasCommonFlightWithFA = hasCommonFlightWithFA;
        $scope.showFlightsForCrewMember = showFlightsForCrewMember;
        $scope.filteredByFeedbackDate = filteredByFeedbackDate;

        /**
         * Display a  successful save message according to the save status 
         * @memberof AssessmentCtrl
         * @param {string} state  the state of the selected Cabin Crew Feedback
         */
        function infoSaveOperation(state) {
            if (state == 'Completed') {
                $scope.infosaveactiontype = state;
                $scope.infosaveaction = true;
            } else if (state == 'Draft') {
                $scope.infosaveactiontype = state;
                $scope.infosaveaction = true
            } else if (state == 'discard') {
                $scope.infosaveactiontype = state;
                $scope.infosaveaction = true
            }

            $timeout(function () {
                $scope.infosaveaction = false;
            }, 5000);

        }

        /**
         * Convers date string to JS object
         * @memberof AssessmentCtrl
         * @param {string} ScheduledArrival The string date of ScheduledArrival 
         * @returns {Object} ScheduledArrival
         */
        function orderByDate(item) {
            var date = new Date(item.ScheduledArrival);
            return date;
        }

        /**
         * Clear Remarks
         * @memberof AssessmentCtrl
         * @param {string} item The Crew assessment Template question item 
         */
        function clearRemarks(item) {
            // put preset comments
            if (item != null && item.ItemDescr) {
                item.ItemDescr = null;
            }

            if (item != null && item.Review) {
                item.Review = null;
            }
        }

        /**
         * Returns the avarage score of the questions.
         * @memberof AssessmentCtrl
         * @param {array} items The Crew assessment Template question items 
         * @returns {number} retval
         */
        function avgValue(items) {
            var sum = 0;
            if (!items || items.length == 0) {
                return sum;
            }
            for (var i = 0; i < items.length; i++) {
                if (items[i]) {
                    sum = sum + parseInt(items[i].ItemValue);
                }
            }
            var retval = (sum / items.length) ? (sum / items.length).toFixed(1) : '-';
            return retval;
        }

        /**
         * Updates the value for the selected crewmember for this Cabin Crew Feedback and update the temporary Cabin Crew Feedback
         * @memberof AssessmentCtrl 
         * @param {object} crewMember The Crew member
         * @param {object} assessment The Crew assessment 
         */
        function updateValues(crewMember, assessment) {
            // Check if review exists
            var hasReview = crewMember.Review != null && crewMember.Review.trim().length > 0;

            // Check if all critical ratings have comments
            var hasCriticalRatingsWithoutComments = false;
            if (crewMember.assessmentItems) {
                for (var i = 0; i < crewMember.assessmentItems.length; i++) {
                    var item = crewMember.assessmentItems[i];
                    if ((item.ItemValue === '1' || item.ItemValue === '5') &&
                        (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
                        hasCriticalRatingsWithoutComments = true;
                        break;
                    }
                }
            }

            // Member is completed only if has review AND no critical ratings without comments
            crewMember.IsCompleted = hasReview && !hasCriticalRatingsWithoutComments;

            CrewAssessmentFactory.saveTempAssessment(assessment, $scope.flight.FlightId);
        }
        $scope.hasInvalidCriticalRatings = hasInvalidCriticalRatings;

        /**
         * Evaluate if this Cabin Crew Feedback is valid and ready to send
         * @memberof AssessmentCtrl 
         * @param {object} assessment The Crew assessment 
         * @returns {boolean} isCompleted
         */
        // function IsCompleted(crewAssessment) {
        //     var isCompleted = true;
        //     for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
        //         if (!(crewAssessment.CrewAssessmentMembers[j].Review != null && crewAssessment.CrewAssessmentMembers[j].Review.trim().length > 0)) {
        //             if (!crewAssessment.CrewAssessmentMembers[j].IsExist && (crewAssessment.CrewAssessmentMembers[j].IsValid || crewAssessment.CrewAssessmentMembers[j].IsOverride)) {
        //                 isCompleted = false;
        //             }
        //         }
        //     }

        //     return isCompleted;
        // }
        function IsCompleted(crewAssessment) {
            var isCompleted = true;

            if (!crewAssessment || !Array.isArray(crewAssessment.CrewAssessmentMembers)) {
                return false;
            }

            for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
                var member = crewAssessment.CrewAssessmentMembers[j];

                // Skip if member doesn't exist or is not applicable
                if (member.IsExist || (!member.IsValid && !member.IsOverride)) {
                    continue;
                }

                // Check if review is required and missing
                if (!(member.Review != null && member.Review.trim().length > 0)) {
                    isCompleted = false;
                }

                // Check if any assessment item has critical rating (1 or 5) without comment
                if (member.assessmentItems) {
                    for (var i = 0; i < member.assessmentItems.length; i++) {
                        var item = member.assessmentItems[i];
                        if ((item.ItemValue === '1' || item.ItemValue === '5') &&
                            (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
                            isCompleted = false;
                        }
                    }
                }
            }

            return isCompleted;
        }

        function hasInvalidCriticalRatings(crewAssessment) {
            for (var j = 0; j < crewAssessment.CrewAssessmentMembers.length; j++) {
                var member = crewAssessment.CrewAssessmentMembers[j];

                // Skip if member doesn't exist or is not applicable
                if (member.IsExist || (!member.IsValid && !member.IsOverride)) {
                    continue;
                }

                if (member.assessmentItems) {
                    for (var i = 0; i < member.assessmentItems.length; i++) {
                        var item = member.assessmentItems[i];
                        if ((item.ItemValue === '1' || item.ItemValue === '5') &&
                            (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        /**
         * Evaluate if this Cabin Crew Feedback is synched
         * @memberof AssessmentCtrl 
         * @param {object} assessment The Crew assessment 
         * @returns {boolean} IsSynched
         */
        function IsSynched() {
            var IsSynched = false;
            if (crewAssessment  && crewAssessment.Status == "Stored") {
                IsSynched = true;
            }
            return IsSynched;
        }

        /**
         * Save the Cabin Crew Feedback
         * @memberof AssessmentCtrl 
         * @param {object} assessment The Cabin Crew Feedback
         */
        function saveAssessment(assessment) {
            CrewAssessmentFactory.setCrewAssessmentToStorage(assessment);
            CrewAssessmentFactory.updateFlightsAssessment(assessment);
        }

        /**
         * Save the Cabin Crew Feedback As Completed
         * @memberof AssessmentCtrl 
         * @param {object} assessment The Cabin Crew Feedback
         */
        function saveClicked(assessment) {
            assessment.Status = 'Completed'
            saveAssessment(assessment);
            infoSaveOperation(assessment.Status);
            SettingsMain.setEditingPage(null);
            CrewAssessmentFactory.clearTempAssessment();
            $location.path('/flightinfo/' + $scope.flight.FlightId);
        }

        /**
         * Discard all the changes on the cabin crew feedback that are not saved
         * @memberof AssessmentCtrl 
         */
        function discard() {
            SettingsMain.setEditingPage(null);
            $scope.assessment = CrewAssessmentFactory.getCrewAssessmentFromStorage($scope.flight.assessment.Id);
            infoSaveOperation('discard');
        }

        /**
         * Save the Cabin Crew Feedback As Draft
         * @memberof AssessmentCtrl 
         * @param {object} assessment The Cabin Crew Feedback
         */
        function saveDraftClicked(assessment) {

            assessment.Status = 'Draft'
            saveAssessment(assessment);
            infoSaveOperation(assessment.Status);
            SettingsMain.setEditingPage(null);
            CrewAssessmentFactory.clearTempAssessment();
        }

        /**
         * Open and close the selected Panel
         * @memberof AssessmentCtrl 
         * @param {number} panelId The panel's Id
         */
        function togglePanel(panelId) {
            $('#' + panelId).toggle();
            if (panelId == "info-panel")
                $scope.isPanelOpen = !$scope.isPanelOpen;
        }

        /**
         * The css class for the selected crew member
         * @memberof AssessmentCtrl 
         * @param {Object} crewMember The assessed crew member
         * @returns {string} cssClass
         */
        // function assesmentCSSClass(crewMember) {
        //     if (!crewMember.IsExist && crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
        //         return 'panel-blue';
        //     } else if (!crewMember.IsExist && !crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
        //         return 'panel-orange';
        //     } else if (!crewMember.IsExist && !crewMember.IsValid && !crewMember.IsOverride) {
        //         return 'panel-default';
        //     } else if (crewMember.IsExist) {
        //         return 'panel-green';
        //     }
        // }
        function assesmentCSSClass(crewMember) {
            if (crewMember.IsExist) {
                return 'panel-green';
            }

            if (!crewMember.IsValid && !crewMember.IsOverride) {
                return 'panel-default';
            }

            // Check if has critical ratings without comments
            var hasCriticalWithoutComments = false;
            if (crewMember.assessmentItems) {
                for (var i = 0; i < crewMember.assessmentItems.length; i++) {
                    var item = crewMember.assessmentItems[i];
                    if ((item.ItemValue === '1' || item.ItemValue === '5') &&
                        (!item.ItemDescr || item.ItemDescr.toString().trim().length === 0)) {
                        hasCriticalWithoutComments = true;
                        break;
                    }
                }
            }

            // If has critical ratings without comments, always show orange (incomplete)
            if (hasCriticalWithoutComments) {
                return 'panel-orange';
            }

            // Otherwise, check normal completion status
            if (crewMember.IsCompleted) {
                return 'panel-blue';
            } else {
                return 'panel-orange';
            }
        }
        /**
        * The icon for the selected crew member
        * @memberof AssessmentCtrl 
        * @param {Object} crewMember The assessed crew member
        * @returns {string} iconClass
        */
        function assesmentIconClass(crewMember) {
            if (!crewMember.IsExist && crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
                return 'fa fa-check';
            } else if (!crewMember.IsExist && !crewMember.IsCompleted && (crewMember.IsValid || crewMember.IsOverride)) {
                return 'fa fa-pencil';
            } else if (!crewMember.IsExist && !crewMember.IsValid && !crewMember.IsOverride) {
                return 'fa fa-times';
            } else if (crewMember.IsExist) {
                return 'fa fa-floppy-o';
            }
        }

        // Helper function to format date consistently
        function formatDateToString(date) {
            if (!date) return null;
            var d = new Date(date);
            return d.getFullYear() + '-' + 
                String(d.getMonth() + 1).padStart(2, '0') + '-' + 
                String(d.getDate()).padStart(2, '0');
        }

        function filteredByFeedbackDate(flight) {
            // Format both dates to yyyy-MM-dd 
            var flightDate = formatDateToString(flight.ScheduledDepartureDateUTC);
            var feedbackDate = formatDateToString($scope.feedbackDate);
            return flightDate === feedbackDate;
        };

        function showFlightsForCrewMember(crewMember) {
            if (!crewMember || !crewMember.aimsId) {
                crewMember.filteredFlights = [];
                return;
            }

            var result = [];
            
            // Format feedback date 
            var feedbackDateFormatted = formatDateToString($scope.feedbackDate);
            var commonFlightsWithFA = localStorageMD5Service.get('CommonFlightsWithFA') || [];
            
            // Loop through all common flights with Flight Attendants (FA)
            (commonFlightsWithFA || []).forEach(function(cf) {       

                // Check if the current SA matches the given crew member
                if (cf.FaAimsId === crewMember.aimsId) {
                    // Loop through all flights for this FA
                    (cf.Flights || []).forEach(function(f) {
                        var flightDateFormatted = formatDateToString(f.ScheduledDepartureDateUTC || f.FlightDate);        
                        
                        // If the flight date matches the feedback date, include it
                        if (flightDateFormatted === feedbackDateFormatted) {
                            result.push(f);
                        }
                    });
                }
            });
            
            // Save the filtered flights into the crew member object
            crewMember.filteredFlights = result;
        };

        // Checks if there is at least one common flight with this crew member
        function hasCommonFlightWithFA(crewMember) {
            // If filteredFlights hasn't been calculated yet, calculate it now
            if (!crewMember.filteredFlights) {
                $scope.showFlightsForCrewMember(crewMember);
            }
            
            return crewMember.filteredFlights && crewMember.filteredFlights.length > 0;
        };


    }
})();